/** Display logo is 52×20mm; 300dpi only needs ~614×236px. Source PNG is 1994×1008. */
export const PDF_LOGO_MAX_WIDTH_PX = 640;
export const PDF_LOGO_MAX_HEIGHT_PX = 320;

export function pdfLogoTargetSize(
  srcW,
  srcH,
  maxW = PDF_LOGO_MAX_WIDTH_PX,
  maxH = PDF_LOGO_MAX_HEIGHT_PX
) {
  const width = Number(srcW) || 1;
  const height = Number(srcH) || 1;
  const scale = Math.min(1, maxW / width, maxH / height);
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  };
}

export function pdfImageFormat(dataUrl) {
  if (typeof dataUrl === "string" && /^data:image\/jpe?g/i.test(dataUrl)) return "JPEG";
  return "PNG";
}

/** Downscale + JPEG so jsPDF does not embed the full uncompressed 1994×1008 PNG (~7.7MB). */
export function optimizeImageForPdf(dataUrl, options = {}) {
  const maxWidth = options.maxWidth ?? PDF_LOGO_MAX_WIDTH_PX;
  const maxHeight = options.maxHeight ?? PDF_LOGO_MAX_HEIGHT_PX;
  const quality = options.quality ?? 0.82;
  if (typeof Image === "undefined" || typeof document === "undefined" || !dataUrl) {
    return Promise.resolve(dataUrl);
  }
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      try {
        const { width, height } = pdfLogoTargetSize(img.width, img.height, maxWidth, maxHeight);
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, width, height);
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      } catch {
        resolve(dataUrl);
      }
    };
    img.onerror = () => resolve(dataUrl);
    img.src = dataUrl;
  });
}
